export enum EventTabState {
    upcoming = 1,
    myEvents = 2,
    search = 3
}